/* tslint:disable */
/* eslint-disable */
/**
 * Docusign API
 * Docusign is a service that allows the user to send the documents for signing
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: o365g_ordertakingteam_irssemal@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AccountTemplate } from './AccountTemplate';
import {
    AccountTemplateFromJSON,
    AccountTemplateFromJSONTyped,
    AccountTemplateToJSON,
} from './AccountTemplate';

/**
 * 
 * @export
 * @interface AccountTemplates
 */
export interface AccountTemplates {
    /**
     * A list of templates associated with the account
     * @type {Array<AccountTemplate>}
     * @memberof AccountTemplates
     */
    accountTemplates?: Array<AccountTemplate>;
}

/**
 * Check if a given object implements the AccountTemplates interface.
 */
export function instanceOfAccountTemplates(value: object): boolean {
    return true;
}

export function AccountTemplatesFromJSON(json: any): AccountTemplates {
    return AccountTemplatesFromJSONTyped(json, false);
}

export function AccountTemplatesFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountTemplates {
    if (json == null) {
        return json;
    }
    return {
        
        'accountTemplates': json['accountTemplates'] == null ? undefined : ((json['accountTemplates'] as Array<any>).map(AccountTemplateFromJSON)),
    };
}

export function AccountTemplatesToJSON(value?: AccountTemplates | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'accountTemplates': value['accountTemplates'] == null ? undefined : ((value['accountTemplates'] as Array<any>).map(AccountTemplateToJSON)),
    };
}

